import Vue from 'vue';
import { http } from '../../http';
import Apps from '../../../core/Apps';
import orderBy from 'lodash/orderBy'

export default {
    state: {
        surveys: [],
        followUpSurveys: [],
        loaded: false,
        loading: false,
        sortBy: 'created_at',
        sortDirection: 'desc',
    },

    mutations: {
        setSurveys(state, surveys = null) {
            state.surveys = surveys || [];
        },

        addSurvey(state, survey) {
            state.surveys.push({ ...survey });
        },

        deleteSurvey(state, survey) {
            let id = typeof survey === 'object' ? survey.id : parseInt(survey);

            state.surveys = state.surveys.filter(s => s.id !== id);
        },

        updateSurvey(state, survey) {
            let id = typeof survey === 'object' ? survey.id : parseInt(survey);
            let index = state.surveys.findIndex(s => s.id === id);

            if (index >= 0) {
                Vue.set(state.surveys, index, { ...survey });
            } else {
                state.surveys.push({ ...survey });
            }
        },

        setFollowUpSurveys(state, rules) {
            state.followUpSurveys = rules;
        },

        addFollowUpSurvey(state, followUpSurvey) {
            state.followUpSurveys.push({ ...followUpSurvey });
        },

        deleteFollowUpSurvey(state, followUpSurvey) {
            let id = typeof followUpSurvey === 'object' ? followUpSurvey.id : parseInt(followUpSurvey);

            state.followUpSurveys = state.followUpSurveys.filter(fs => fs.id !== id);
        },

        updateFollowUpSurvey(state, followUpSurvey) {
            let id = typeof followUpSurvey === 'object' ? followUpSurvey.id : parseInt(followUpSurvey);
            let index = state.followUpSurveys.findIndex(fs => fs.id === id);

            if (index >= 0) {
                Vue.set(state.followUpSurveys, index, { ...followUpSurvey });
            } else {
                state.followUpSurveys.push({ ...followUpSurvey });
            }
        },
        sortSurveys(state, sort) {
            state.sortBy = sort.name;
            state.sortDirection = sort.direction;
        }
    },

    getters: {
        loading: (state, getters) => {
            return state.loading;
        },
        all: (state, getters) => {
            return state.surveys;
        },
        find: (state, getters) => (survey) => {
            const surveyId = typeof survey === 'object' && survey !== null ? survey.id : parseInt(survey) || 0;

            return getters.all.find(p => p.id === surveyId);
        },

        isLoaded(state, getters) {
            return state.loaded;
        },

        followUpSurveys: (state, getters) => {
            return state.followUpSurveys;
        },

        followUpSurveysForSurvey: (state, getters) => (surveyId) => {
            return (getters.followUpSurveys || []).filter(f => f.survey_id === surveyId);
        },
        sortedSurveys: (state) => {
            return orderBy(state.surveys, [state.sortBy], [state.sortDirection])
        }
    },

    actions: {
        load ({ commit, state, rootGetters }) {
            if (state.loaded || state.loading) {
                return;
            }

            state.loading = true;

            if ( ! rootGetters['apps/isAppEnabled'](Apps.Surveys)) {
                state.loaded = true;
                state.loading = false;
                return;
            }

            http.get('/app/settings/surveys')
                .then(({ data }) => {
                    commit('setSurveys', data.surveys);
                    commit('setFollowUpSurveys', data.follow_up_surveys);
                    state.loaded = true;
                    state.loading = false;
                }).catch(() => {
                    state.loading = false;
                });
        },

        reload({ state, dispatch }) {
            state.loaded = false;
            dispatch('load');
        },
    },
};
